import { Spx } from '@wix/thunderbolt-becky-types'

export const CONTAINER_TYPES = {
	Page: true,
	MasterPage: true,
	AppPage: true,
	VerticalRepeater: true,
	QuickActionBar: true,
	PageGroup: true,
	SiteRegionContainer: true,
	Container: true,
	MediaBox: true,
	HoverBox: true,
	PopupContainer: true,
	Group: true,
	FormContainer: true,
	WSiteStructure: true,
	HeaderContainer: true,
	FooterContainer: true,
	PagesContainer: true,
	StripContainer: true,
	StripColumnsContainer: true,
	ClassicSection: true,
	Column: true,
	MediaPlayer: true,
	ScreenWidthContainer: true,
	Area: true,
	BoxSlideShow: true,
	StateBox: true,
	StateStrip: true,
	StateBoxState: true,
	StateBoxFormState: true,
	StateStripState: true,
	StripContainerSlideShow: true,
	BoxSlideShowSlide: true,
	StripContainerSlideShowSlide: true,
	Repeater: true,
	MediaContainer: true,
	MenuContainer: true,
	AppWidget: true,
	Popover: true,
	RefComponent: true,
	Section: true,
	HeaderSection: true,
	FooterSection: true,
	MembersAreaSection: true,
	MultiStateBox: true,
	MegaMenuContainerItem: true,
	StretchedContainer: true,
	SettingsPanelContainer: true,
	SingleTab: true,
	AccordionItem: true,
	SelectableContainer: true,
}

export const resolveSpxAttribute = (value: string | number, spx?: Spx) => {
	const refWidth = spx ? spx.refWidth : undefined
	const shouldResolveSpx = spx ? spx.resolverType === 'scale' : false
	return `${value}`
		.split(' ')
		.map((valueWithoutSpaces) =>
			valueWithoutSpaces
				.split('/')
				.map((valueWithoutSlash) => {
					if (valueWithoutSlash.endsWith('spx')) {
						return shouldResolveSpx
							? resolveSpxValue(valueWithoutSlash, refWidth)
							: `${parseInt(valueWithoutSlash, 10)}px`
					} else if (!isNaN(Number(valueWithoutSlash))) {
						return `${valueWithoutSlash}px`
					}
					return valueWithoutSlash
				})
				.join('/')
		)
		.join(' ')
}
export const resolveSpxValue = (valueWithoutSlash: string, refWidth: number | undefined) => {
	const valueWithoutSpx = Number(`${valueWithoutSlash}`.replace('spx', ''))
	return refWidth ? `${(valueWithoutSpx / refWidth) * 100}cqw` : `${valueWithoutSpx}px`
}
